import { useEffect } from 'react'

import { useCookies } from 'react-cookie'
import { USER_MODE_DEV } from './Environment'
import { AppContainer, SimulationNumberMain } from './GlobalStyles'
import { t } from './i18n'
import { Router } from './Routes/routes'
import { useContextStore } from './Stores/contextStore'
import { useRunPetisSimulationStore } from './Stores/useRunPetisSimulationStore'
import { GlobalContextInterface } from './Types/core'

export const App = () => {
  const { setGlobalContext } = useContextStore()
  const { runPetisSimulation, isRequestLoading } = useRunPetisSimulationStore()
  const [, setCookies] = useCookies()

  function setGlobalContextParams(iFrameDiv: any) {
    const globalContext: GlobalContextInterface = {
      protocol: iFrameDiv?.getAttribute('data-protocol')
        ? iFrameDiv?.getAttribute('data-protocol')
        : '',
      username:
        iFrameDiv?.getAttribute('data-username') || USER_MODE_DEV.username,
      environment:
        iFrameDiv?.getAttribute('data-environment') ||
        USER_MODE_DEV.environment,
      produtoid:
        iFrameDiv?.getAttribute('data-produtoid') || USER_MODE_DEV.produtoid,
      nif: iFrameDiv?.getAttribute('data-nif') || '',
      token: iFrameDiv?.getAttribute('data-token') || USER_MODE_DEV.token,
    }
    setGlobalContext(globalContext)
  }

  useEffect(() => {
    const div = document.getElementById('root')
    const domainCookie = div?.getAttribute('data-cookie-domain') || ''

    if (div?.dataset.token !== undefined && domainCookie.length > 0) {
      setCookies('auth', div?.dataset.token.replace('%20', ' '), {
        path: '/',
        domain: domainCookie,
      })
    }
    if (div?.dataset.username !== undefined) {
      setCookies('pts_username', div?.dataset.username || '')
    }

    setGlobalContextParams(div)
  }, [])

  return (
    <AppContainer>
      {!isRequestLoading &&
        (runPetisSimulation?.runPetisSimulationResponse?.quoteId || '')
          ?.length > 0 && (
          <SimulationNumberMain>
            {t('general.simulation')}{' '}
            {runPetisSimulation?.runPetisSimulationResponse?.quoteId}
          </SimulationNumberMain>
        )}
      <Router />
    </AppContainer>
  )
}
